import React, { useState, useEffect } from 'react';
import './index.css';
import {
  FormGroup,
  Container,
  Col,
  Row,
  Input,
  Modal,
  ModalBody,
  Label,
  Form,
} from 'reactstrap';
import swal from 'sweetalert';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  addDealerOwner,
  editDealerOwner,
  dealerDocumentUpload,
  editDealer,
  getStateDistrictCity,
} from '../../../constants/apiCalls';
import moment from 'moment';
import CustomSpinner from '../../../Components/CustomSpinner/CustomSpinner';
import ModalService from '../../../services/ModalService';
import { DashBoardTitle } from '../../../Components/Title';
import uploadImg from '../../../images/upload2.png';
import closeImg from '../../../images/close.png';
import previewImg from '../../../images/previewImg.png';
import { Breadcrumbs } from '../../../Components/Breadcrumbs/Breadcrumbs';
import Storage from '../../../services/Storage';
import DateService from '../../../services/DateService';
import {
  AddUserButton,
  CommonButton,
} from '../../../Components/CommonComponents';
import UploadDocPreview from '../../../Components/CustomModal/UploadDocPreview/UploadDocPreview';
import { handleErrorMessage } from '../../../utils/utils';
import { useDispatch, useSelector } from 'react-redux';
import { dealerInfoAction } from '../../../reducers/DealerReducer';
import AppHeader from '../../../Layout/AppHeader';
import AppSidebar from '../../../Layout/AppSidebar';
import { dateFormat } from '../../../constants/dateFormat';

const AddOwner = () => {
  const [isLoading, setIsloading] = useState(false);
  const [isModalLoading, setIsModalLoading] = useState(false);
  const [editData, setEditData] = useState('');
  const [modal, setModal] = useState(false);
  const [selectedDistrict, setSelectedDistrict] = useState('');
  const [selectedCity, setSelectedCity] = useState('');
  const [slectedState, setSelectedState] = useState('');
  const [currentRadioValue, setCurrentValue] = useState('');
  const [sameMobileCheck, setSameMobileCheck] = useState(false);
  const [imgUpload, setImgUpload] = useState('');
  const [anniversaryDate, setAnniversaryDate] = useState('');
  const [ownerId, setOwnerId] = useState('');
  const [isActiveOwner, setActiveOwner] = useState(false);
  const [activeOwner, setOwner] = useState('');
  const [isPreviewRemove, setIsPreviewRemove] = useState(false);
  const initialValues = {
    ownerName: '',
    primaryContactMobile: '',
    email: '',
    primaryContactWhatsapp: '',
    pincode: '',
    address: '',
    birthDate: '',
    designation: '',
  };
  const [formValues, setFormValues] = useState(initialValues);
  const [imagePreview, setImagePreview] = useState('');
  const [previewImgModal, setPreviewImgModal] = useState(false);
  const [popupImgPreview, setPopupImgPreview] = useState('');
  const [ownerTitle, setOwnerTitle] = useState({});
  const [title, setTitle] = useState('');
  const [selectedStateId, setSelectedStateId] = useState('');
  const [selectedDistrictId, setSelectedDistrictId] = useState('');
  const [selectedCityId, setSelectedCityId] = useState('');

  const navigate = useNavigate();
  let location = useLocation();
  let stringArr = location.pathname.split(/(\d+)/);
  let userId = stringArr[1];

  const dispatch = useDispatch();
  const { dealerObj } = useSelector((state) => state.DealerReducer);

  useEffect(() => {
    if (userId) {
      setIsloading(true);
      dispatch(dealerInfoAction(parseInt(userId), setIsloading));
    }
  }, []);

  useEffect(() => {
    const sortedOwner =
      dealerObj.owners && dealerObj.owners.length > 0
        ? [
          ...dealerObj.owners.filter(
            ({ is_primary_contact }) => is_primary_contact,
          ),
          ...dealerObj.owners.filter(
            ({ is_primary_contact }) => !is_primary_contact,
          ),
        ]
        : [];

    setEditData(sortedOwner);
    // setImagePreview(dealerObj.owners.image);
    setOwner(dealerObj.business_type);
    setIsloading(false);
    setOwnerTitle({
      name: dealerObj.business_name,
      page: dealerObj.page_7,
    });

    setSelectedStateId(dealerObj.state_id);
    setSelectedDistrictId(dealerObj.district_id);
    setSelectedCityId(dealerObj.city_id);
  }, [dealerObj]);

  useEffect(() => { }, [imgUpload, ownerTitle]);

  const removeSelectedImage = () => {
    setImgUpload();
    setImagePreview();
    setPreviewImgModal(false);
  };

  const openEdit = (val, key) => {
    if (key === 2) {
      setOwnerId(val.id);
      setFormValues({
        ownerName: val.name,
        primaryContactMobile: val.mobile_number,
        email: val.email,
        primaryContactWhatsapp: val.whatsapp_mobile_number,
        pincode: val.pincode,
        address: val.address,
        birthDate: val && val.birth_date ? DateService.utcToLocalDateOnly(val.birth_date, dateFormat.DATE_FORMAT_4) : "",
        designation: val.designation,
      });
      setAnniversaryDate(val && val.wedding_date ? DateService.utcToLocalDateOnly(val.wedding_date, dateFormat.DATE_FORMAT_4) : "");

      setSelectedStateId(val.state_id);
      setSelectedDistrictId(val.district_id);
      setSelectedCityId(val.city_id);

      setImgUpload(val.image);
      setCurrentValue(val.marital_status);
      setSameMobileCheck(val.ownerName);
      setActiveOwner(val.is_primary_contact);
      setModal(!modal);
    }
  };

  const toggle = (val) => {
    setOwnerId('');
    setAnniversaryDate('');
    setFormValues('');
    setImgUpload('');
    setImagePreview('');
    setSelectedStateId('');
    setSelectedDistrictId('');
    setSelectedCityId('');
    setCurrentValue('');
    setSameMobileCheck(false);
    setActiveOwner(false);
    setModal(!modal);
  };

  useEffect(() => {
    if (formValues.pincode && formValues.pincode.length === 6) {
      getPincodeCityStateDistrict(formValues.pincode);
      // setIsloading(true);
    }
  }, [formValues.pincode]);

  const getPincodeCityStateDistrict = (pincode) => {
    let payload = {
      pincode: pincode,
    };
    getStateDistrictCity((res) => {
      const { success, data, error } = res;
      if (success === true) {
        if (data.length > 0) {
          let allData = data;
          // state array
          let stateArr = [
            ...new Map(allData.map((m) => [m.state_id, m])).values(),
          ]; // remove duplicate state
          setSelectedState(stateArr);
          setSelectedStateId(stateArr[0].state_id); //unique state id

          // District array
          let districtArr = [
            ...new Map(allData.map((m) => [m.district_id, m])).values(),
          ]; // remove duplicate district
          setSelectedDistrict(districtArr);

          // city Arr
          let cityArr = [
            ...new Map(allData.map((m) => [m.city_id, m])).values(),
          ]; // remove duplicate City
          setSelectedCity(cityArr);

          setIsloading(false);
        } else {
          ModalService.openAlert('', 'Please Insert Correct Pincode', 'error');
          setFormValues({ ...formValues, pincode: '' });
          setSelectedState('');
          setSelectedDistrict('');
          setSelectedCity('');
        }
        setIsloading(false);
      } else if (success === false || success === 'undefined') {
        setIsloading(false);
        ModalService.openAlert(
          '',
          handleErrorMessage(error[0].message),
          'error',
        );
      }
      setIsloading(false);
    }, payload);
  };

  const handleStateChange = (e) => {
    let val = e.target.value;
    setSelectedStateId(val);
  };

  useEffect(() => {
    handleDistrictChange();
  }, [selectedDistrictId, selectedStateId]);

  const handleDistrictChange = () => {
    if (selectedDistrictId && selectedStateId) {
      let payload = {
        pincode: formValues.pincode,
      };
      getStateDistrictCity((res) => {
        const { success, data, error } = res;
        if ((success === true) & (data.length > 0)) {
          let distrcitBaseCity = data.filter(
            (elem) => elem.district_id === +selectedDistrictId,
          );
          setSelectedCity(distrcitBaseCity);
          setIsloading(false);
        } else if (success === false || success === 'undefined') {
          setIsloading(false);
          ModalService.openAlert(
            '',
            handleErrorMessage(error[0].message),
            'error',
          );
        }
        setIsloading(false);
      }, payload);
    }
  };

  const handleCityChange = (e) => {
    let val = e.target.value;
    setSelectedCityId(val);
  };

  const handleMobileChange = (e) => {
    let val = e.target.checked;
    setSameMobileCheck(val);
  };

  const handleCommonUpload = (e, key) => {
    if (key === 1) {
      const { name, files } = e.target;
      setFormValues({ ...formValues, [name]: files[0] });

      let formData = new FormData();
      for (let i = 0; i < e.target.files.length; i++) {
        formData.append('files', e.target.files[i]);
      }
      formData.append('ownerimage', true);
      setIsloading(false);
      setIsModalLoading(true);
      dealerDocumentUpload((res) => {
        const { success, data, error } = res;
        if (success === true) {
          setImgUpload(data.imageUrl);
          setIsModalLoading(false);
        } else if (success === false || success === 'undefined') {
          ModalService.openAlert(
            '',
            handleErrorMessage(error[0].message),
            'error',
          );
          setIsModalLoading(false);
        }
        setIsModalLoading(false);
      }, formData);
    }
  };

  const handleChange = (e, key) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });

    if (name === 'pincode' && value.length < 6) {
      setSelectedState('');
      setSelectedDistrict('');
      setSelectedCity('');
      setSelectedStateId('');
      setSelectedDistrictId('');
      setSelectedCityId('');
    }
  };

  const handleSubmit = (evt) => {
    evt.preventDefault();

    // Email Pattern Validation
    if (formValues.email) {
      let regEmail = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
      if (!formValues.email || regEmail.test(formValues.email) === false) {
        swal('Invalid Email Address!!');
        return false;
      } else if (formValues.email && regEmail.test(formValues.email) === true) {
        // return true
      }
    }

    let payload = {
      user_id: parseInt(userId),
      name: formValues.ownerName,
      email: formValues.email,
      image: imgUpload,
      address: formValues.address,
      state_id: selectedStateId ? selectedStateId : null,
      district_id: selectedDistrictId ? selectedDistrictId : null,
      city_id: selectedCityId ? selectedCityId : null,
      pincode: formValues.pincode,
      birth_date: formValues.birthDate,
      designation: formValues.designation,
      wedding_date:
        currentRadioValue === 'married'
          ? anniversaryDate === ''
            ? null
            : anniversaryDate
          : null,
      mobile_number: formValues.primaryContactMobile,
      marital_status: currentRadioValue,
      is_primary_contact:
        // activeOwner === 'Sole proprietorship' ? true : isActiveOwner,
        isActiveOwner,
      whatsapp_mobile_number:
        sameMobileCheck === true
          ? (formValues.primaryContactWhatsapp =
            formValues.primaryContactMobile)
          : formValues.primaryContactWhatsapp,
    };

    if (ownerId) {
      let editPayload = {
        id: ownerId,
        name: formValues.ownerName,
        email: formValues.email,
        image: imgUpload,
        address: formValues.address,
        state_id: selectedStateId ? selectedStateId : null,
        district_id: selectedDistrictId ? selectedDistrictId : null,
        city_id: selectedCityId ? selectedCityId : null,
        pincode: formValues.pincode,
        birth_date: formValues.birthDate,
        designation: formValues.designation,
        wedding_date: currentRadioValue === 'married' ? anniversaryDate : null,
        mobile_number: formValues.primaryContactMobile,
        marital_status: currentRadioValue,
        is_primary_contact: isActiveOwner,
        whatsapp_mobile_number:
          sameMobileCheck === true
            ? formValues.primaryContactMobile
            : formValues.primaryContactWhatsapp,
      };
      setIsloading(false);
      setIsModalLoading(true);
      editDealerOwner((res) => {
        const { success, message, error } = res;
        if (success === true) {
          ModalService.openAlert('', message, 'success');
          setImgUpload('');
          dispatch(dealerInfoAction(parseInt(userId), setIsloading));
          setModal(!modal);
          let dealerPayload = {
            id: parseInt(userId),
            page_7: 1,
          };
          editDealer((res) => { }, dealerPayload);
        } else if (success === false || success === 'undefined') {
          ModalService.openAlert(
            '',
            handleErrorMessage(error[0].message),
            'error',
          );
          setModal(!modal);
        }
        setIsloading(false);
        setIsModalLoading(false);
      }, editPayload);
    } else if (parseInt(userId)) {
      setIsloading(false);
      setIsModalLoading(true);
      addDealerOwner((res) => {
        const { success, message, error } = res;
        if (success === true) {
          let dealerPayload = {
            id: parseInt(userId),
            page_7: 1,
          };
          editDealer((res) => { }, dealerPayload);
          ModalService.openAlert('', message, 'success');
          dispatch(dealerInfoAction(parseInt(userId), setIsloading));
          setModal(!modal);
          setImgUpload('');
        } else if (success === false || success === 'undefined') {
          ModalService.openAlert(
            '',
            handleErrorMessage(error[0].message),
            'error',
          );
          setModal(!modal);
        }
        setIsloading(false);
        setIsModalLoading(false);
      }, payload);
    }
  };

  const handleSaveAsDraft = (evt) => {
    evt.preventDefault();
    let dealerPayload = {
      id: parseInt(userId),
      page_7: 1,
    };
    if (editData.length >= 0) {
      if (
        editData.findIndex((owner) => owner.is_primary_contact === true) === -1
      ) {
        ModalService.openAlert(
          '',
          'At least one Active owner needed to complete verification process ',
          'error',
        );
      } else {
        setIsloading(true);
        editDealer((res) => {
          const { success, message, error } = res;
          if (success === true) {
            ModalService.openAlert('', message, 'success');
            setIsloading(false);
            const lastRoute = Storage.backBreadcrumbsButton();
            navigate(lastRoute.url, { replace: true });
          } else if (success === false || success === 'undefined') {
            ModalService.openAlert(
              '',
              handleErrorMessage(error[0].message),
              'error',
            );
            setIsloading(false);
          }
          setIsModalLoading(false);
        }, dealerPayload);
      }
    }
  };

  const closeModalEdit = () => {
    setModal(!modal);
  };

  const togglePreviewImgModal = (val, title, key) => {
    if (key) {
      setPopupImgPreview(val);
      setTitle(title);
    }
    setPreviewImgModal(!previewImgModal);
  };

  return (
    <>
      <AppHeader />
      <div className='app-main'>
        <AppSidebar />
        <div className='app-main__outer'>
          <div className='app-main__inner rms-wrapper'>
            <div id="AddOwner">
              {isLoading && <CustomSpinner />}
              <div className="pageWrapper">
                <Container fluid>
                  <Row>
                    <Col xs={12}>
                      <div className="pageheader">
                        <DashBoardTitle
                          dashBorardName={
                            ownerTitle.page === 1
                              ? ownerTitle.name
                              : 'New Dealer Registration'
                          }
                        />
                      </div>
                    </Col>
                    <Col xs={12}>
                      <Breadcrumbs title="Owners Information" />
                    </Col>
                  </Row>
                  <div className="addOwnerBlock">
                    <div className="addOwnerBlockInner">
                      <Row>
                        <Col xs={12}>
                          <div className="dealerRegBlocktitle pb-0 text-center noprint">
                            Owners Information
                          </div>
                        </Col>
                      </Row>
                      {editData.length > 0 &&
                        editData.map((val, index) => {
                          return (
                            <div key={index} className="addActiveOwner">
                              <Row>
                                <Col xs={12}>
                                  <div className="d-flex flex-wrap align-items-center justify-content-between">
                                    <div className="dealerRegBlocktitleInner subTitle">
                                      {val.is_primary_contact
                                        ? 'Active Owner'
                                        : 'Other Owner'}
                                    </div>
                                    <div className="d-flex flex-wrap ownerAction">
                                      <i
                                        onClick={() => openEdit(val, 2)}
                                        className="fa fa-edit editIcon noprint"
                                      ></i>
                                    </div>
                                  </div>
                                </Col>
                                <Col lg={10}>
                                  <div className="ownerdatablock">
                                    <div className="info">
                                      <div className="common-heading">Owners Name</div>
                                      <div className="subData">{val.name}</div>
                                    </div>
                                    <div className="info">
                                      <div className="common-heading">Mobile No</div>
                                      <div className="subData">{val.mobile_number}</div>
                                    </div>
                                    <div className="info">
                                      <div className="common-heading">Whatsapp No</div>
                                      <div className="subData">
                                        {val.whatsapp_mobile_number}
                                      </div>
                                    </div>
                                    <div className="info">
                                      <div className="common-heading">Email</div>
                                      <div className="subData">{val.email}</div>
                                    </div>
                                    <div className="info">
                                      <div className="common-heading">Designation</div>
                                      <div className="subData">{val.designation}</div>
                                    </div>
                                    <div className="info">
                                      <div className="common-heading">
                                        Marital Status
                                      </div>
                                      <div className="subData">
                                        {val.marital_status}
                                      </div>
                                    </div>
                                    <div className="info">
                                      <div className="common-heading">Birth Date</div>
                                      <div className="subData">
                                        <i
                                          style={{ color: '#545CD8' }}
                                          className="fa fa-calendar mr-1 noprint"
                                        ></i>{' '}
                                        {DateService.localDateOnly(val.birth_date) ||
                                          'N/A'}
                                      </div>
                                    </div>
                                    {val.wedding_date && (
                                      <div className="info">
                                        <div className="common-heading">
                                          Marriage 'A Date
                                        </div>
                                        <div className="subData">
                                          <i
                                            style={{ color: '#545CD8' }}
                                            className="fa fa-calendar mr-1 noprint"
                                          ></i>
                                          {DateService.localDateOnly(
                                            val.wedding_date,
                                          ) || 'N/A'}
                                        </div>
                                      </div>
                                    )}
                                    <div className="info">
                                      <div className="common-heading">Pincode</div>
                                      <div className="subData">{val.pincode}</div>
                                    </div>
                                    <div className="info">
                                      <div className="common-heading">State</div>
                                      <div className="subData">{val.state_name}</div>
                                    </div>
                                    <div className="info">
                                      <div className="common-heading">City/Town</div>
                                      <div className="subData">{val.city_name}</div>
                                    </div>
                                    <div className="info">
                                      <div className="common-heading">District</div>
                                      <div className="subData">{val.district_name}</div>
                                    </div>
                                    <div className="info">
                                      <div className="common-heading">
                                        Residential Address
                                      </div>
                                      <div className="subData">{val.address}</div>
                                    </div>
                                  </div>
                                </Col>
                                <Col lg={2}>
                                  <div
                                    className="d-flex justify-content-lg-end ownerImg"
                                    onClick={() => {
                                      setIsPreviewRemove(false);
                                      if (val.image.includes('.pdf')) {
                                        window.open(val.image, '_blank');
                                      } else {
                                        togglePreviewImgModal(
                                          val.image,
                                          'Owner Image',
                                          1,
                                        );
                                      }
                                    }}
                                  >
                                    <img
                                      src={val.image}
                                      width={'128px'}
                                      alt="ownerImg"
                                      className="img-fluid"
                                    />
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                  <div className="buttonArea">
                    <Row>
                      {editData &&
                        editData.length > 0 &&
                        activeOwner === 'Sole proprietorship' ? null : (
                        <Col xs={12}>
                          <div className="addUserBtnBlock d-flex flex-wrap justify-content-center">
                            <AddUserButton
                              onClick={() => toggle(editData)}
                              name={
                                editData.length > 0
                                  ? 'Add More Owners Information'
                                  : 'Add Owners Information'
                              }
                            />
                          </div>
                        </Col>
                      )}
                      <Col xs={12}>
                        <div className="common-buttons d-flex flex-wrap align-items-center justify-content-center">
                          <CommonButton
                            name={'Submit'}
                            btnClass={'btnPrimary'}
                            type="button"
                            onClick={handleSaveAsDraft}
                            disabled={editData.length === 0}
                          />
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Container>
              </div>

              {/* Add / Edit Owner Modal */}
              <Modal id="Owner-popup" isOpen={modal} toggle={toggle} centered>
                {isModalLoading && <CustomSpinner />}
                <ModalBody>
                  <div className="d-flex justify-content-end mb-2 closeModalBtn">
                    <img src={closeImg} alt="closeImg" onClick={closeModalEdit} />
                  </div>
                  <Container>
                    <Row>
                      <Col xs={12}>
                        <div className="modalTitle">Owners information</div>
                      </Col>
                    </Row>
                    <Form onSubmit={handleSubmit} id="create-course-form">
                      <Row>
                        <Col md={4}>
                          <FormGroup className="common-group">
                            <Label className="common-input-label">
                              Name of Proprietor/Partner
                              <span className="required">*</span>
                            </Label>
                            <Input
                              required
                              className="common-input"
                              placeholder="Type Here"
                              name="ownerName"
                              autoComplete="off"
                              onChange={handleChange}
                              value={
                                formValues.ownerName === null ||
                                  formValues.ownerName === 'undefined'
                                  ? ''
                                  : formValues.ownerName
                              }
                              type="text"
                              onKeyPress={(event) => {
                                if (
                                  /^(?=.{0,20}$)(?![_.])(?!.*[_.]{2})[0-9._]+(?<![_.])$/.test(
                                    event.key,
                                  )
                                ) {
                                  event.preventDefault();
                                }
                              }}
                            />
                          </FormGroup>
                        </Col>
                        <Col md={4}>
                          <Label className="common-input-label">
                            Mobile Number<span className="required">*</span>
                          </Label>
                          <FormGroup className="country-code-group">
                            <Input
                              className="country-code-input"
                              type="text"
                              disabled
                              value="+91"
                            />
                            <div className="mobile-number w-100">
                              <Input
                                required
                                className="common-input w-100"
                                placeholder="Type Here"
                                name="primaryContactMobile"
                                maxLength={10}
                                autoComplete="off"
                                onKeyPress={(event) => {
                                  if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                  }
                                }}
                                value={
                                  formValues.primaryContactMobile === null ||
                                    formValues.primaryContactMobile === 'undefined'
                                    ? ''
                                    : formValues.primaryContactMobile
                                }
                                onChange={handleChange}
                                type="text"
                              />
                            </div>
                          </FormGroup>
                        </Col>
                        <Col md={4}>
                          <Label className="common-input-label">
                            Whatsapp Number<span className="required">*</span>
                          </Label>
                          <FormGroup className="country-code-group mb-0">
                            <Input
                              className="country-code-input"
                              type="text"
                              disabled
                              value="+91"
                            />
                            <div className="wp-number w-100">
                              <Input
                                required
                                className="common-input w-100"
                                placeholder="Type Here"
                                autoComplete="off"
                                name="primaryContactWhatsapp"
                                maxLength={10}
                                onKeyPress={(event) => {
                                  if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                  }
                                }}
                                value={
                                  sameMobileCheck === true
                                    ? formValues.primaryContactMobile === null ||
                                      formValues.primaryContactMobile === 'undefined'
                                      ? ''
                                      : formValues.primaryContactMobile
                                    : formValues.primaryContactWhatsapp === null ||
                                      formValues.primaryContactWhatsapp === 'undefined'
                                      ? ''
                                      : formValues.primaryContactWhatsapp
                                }
                                onChange={handleChange}
                                type="text"
                              />
                            </div>
                          </FormGroup>
                          <FormGroup>
                            <Input
                              className="common-checkbox-input ml-0"
                              type="checkbox"
                              placeholder="Type Here"
                              onChange={handleMobileChange}
                              id="mobile-checkbox"
                            />
                            <Label
                              for="mobile-checkbox"
                              className="common-input-label checkboxLabel"
                            >
                              Same as Mobile Number<span className="required"></span>
                            </Label>
                          </FormGroup>
                        </Col>
                        <Col md={4}>
                          <FormGroup className="common-group pt-2">
                            <Label className="common-input-label">
                              Email<span className="required">*</span>
                            </Label>
                            <Input
                              required
                              className="common-input custom-width"
                              type="email"
                              name="email"
                              autoComplete="off"
                              value={
                                formValues.email === null ||
                                  formValues.email === 'undefined'
                                  ? ''
                                  : formValues.email
                              }
                              onChange={handleChange}
                              placeholder="Type Here"
                            />
                          </FormGroup>
                        </Col>
                        <Col md={4}>
                          <FormGroup className="common-group pt-2">
                            <Label className="common-input-label">
                              Designation<span className="required">*</span>
                            </Label>
                            <Input
                              required
                              className="common-input custom-width"
                              type="text"
                              name="designation"
                              autoComplete="off"
                              value={
                                formValues.designation === null ||
                                  formValues.designation === 'undefined'
                                  ? ''
                                  : formValues.designation
                              }
                              onChange={handleChange}
                              placeholder="Type Here"
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={4}>
                          <FormGroup>
                            <Label className="common-input-label">
                              Residential Address<span className="required">*</span>
                            </Label>
                            <Input
                              required
                              type="textarea"
                              name="address"
                              className="address-area w-100"
                              onChange={handleChange}
                              value={
                                formValues.address === null ||
                                  formValues.address === 'undefined'
                                  ? ''
                                  : formValues.address
                              }
                              cols="20"
                              rows="5"
                              autoComplete="off"
                            ></Input>
                          </FormGroup>
                        </Col>
                        <Col md={8}>
                          <Row className="address-alignment">
                            <Col md={6}>
                              <FormGroup>
                                <Label className="common-input-label">
                                  Pincode<span className="required">*</span>
                                </Label>
                                <Input
                                  required
                                  className="address-input"
                                  type="text"
                                  autoComplete="off"
                                  name="pincode"
                                  maxLength={6}
                                  onKeyPress={(event) => {
                                    if (!/[0-9]/.test(event.key)) {
                                      event.preventDefault();
                                    }
                                  }}
                                  value={
                                    formValues.pincode === null ||
                                      formValues.pincode === 'undefined'
                                      ? ''
                                      : formValues.pincode
                                  }
                                  placeholder="Type Here"
                                  onChange={handleChange}
                                />
                              </FormGroup>
                            </Col>
                            <Col md={6}>
                              <FormGroup>
                                <Label className="common-input-label">
                                  State<span className="required">*</span>
                                </Label>
                                <div className="select-wrapper">
                                  <Input
                                    type="select"
                                    id="select"
                                    required
                                    value={
                                      selectedStateId === null ||
                                        selectedStateId === 'undefined'
                                        ? ''
                                        : selectedStateId
                                    }
                                    onChange={handleStateChange}
                                  >
                                    {slectedState.length > 0 ? (
                                      slectedState.map((state, index) => {
                                        return (
                                          <option key={index} value={state.state_id}>
                                            {state.state_name}
                                          </option>
                                        );
                                      })
                                    ) : (
                                      <option disabled value={''}>
                                        Select
                                      </option>
                                    )}
                                  </Input>
                                </div>
                              </FormGroup>
                            </Col>
                            <Col md={6}>
                              <FormGroup>
                                <Label className="common-input-label">
                                  District<span className="required">*</span>
                                </Label>
                                <div className="select-wrapper">
                                  <Input
                                    type="select"
                                    id="select"
                                    required
                                    value={
                                      selectedDistrictId === null ||
                                        selectedDistrictId === 'undefined'
                                        ? ''
                                        : selectedDistrictId
                                    }
                                    onChange={(e) => {
                                      setSelectedDistrictId(e.target.value);
                                      setSelectedCityId('');
                                    }}
                                  >
                                    <option disabled value={''}>
                                      Select
                                    </option>
                                    {selectedDistrict.length > 0
                                      ? selectedDistrict.map((district, index) => {
                                        return (
                                          <option
                                            key={index}
                                            value={district.district_id}
                                          >
                                            {district.district_name}
                                          </option>
                                        );
                                      })
                                      : ''}
                                  </Input>
                                </div>
                              </FormGroup>
                            </Col>
                            <Col md={6}>
                              <FormGroup>
                                <Label className="common-input-label">
                                  City/Town<span className="required">*</span>
                                </Label>
                                <div className="select-wrapper">
                                  <Input
                                    type="select"
                                    id="select"
                                    required
                                    value={
                                      selectedCityId === null ||
                                        selectedCityId === 'undefined'
                                        ? ''
                                        : selectedCityId
                                    }
                                    onChange={handleCityChange}
                                    disabled={!selectedDistrictId}
                                  >
                                    <option disabled value={''}>
                                      Select
                                    </option>
                                    {selectedCity.length > 0
                                      ? selectedCity.map((val, index) => {
                                        return (
                                          <option key={index} value={val.city_id}>
                                            {val.city_or_town_name}
                                          </option>
                                        );
                                      })
                                      : ''}
                                  </Input>
                                </div>
                              </FormGroup>
                            </Col>
                          </Row>
                        </Col>
                        <Col md={4} className="mt-2">
                          <div className="uploadArea">
                            <div className="d-flex align-items-center">
                              <FormGroup className="mb-1 w-100 d-flex align-items-center">
                                <Label className="common-input-label mb-0">
                                  Upload Image of Proprietor / Partner
                                  <span className="required">*</span>
                                </Label>
                                {!(imgUpload || imagePreview) ? (
                                  <Label className="uploadLabel">
                                    <Input
                                      type="file"
                                      name="imgUpload"
                                      onChange={(e) => handleCommonUpload(e, 1)}
                                      accept="image/*"
                                      className={`back-button`}
                                      required={!(imgUpload || imagePreview)}
                                    />
                                    <img
                                      className="uploadImg"
                                      src={uploadImg}
                                      alt="uploadImg"
                                    />
                                  </Label>
                                ) : (
                                  <img
                                    src={previewImg}
                                    alt="previewImg"
                                    className="preViewImg"
                                    onClick={() => {
                                      setIsPreviewRemove(true);
                                      togglePreviewImgModal(
                                        imgUpload || imagePreview,
                                        'Upload Image of Proprietor / Partner',
                                        51,
                                      );
                                    }}
                                  />
                                )}
                              </FormGroup>
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <Row className="mt-2">
                        <Col md={4}>
                          <Label className="marital-status">
                            Marital Status<span className="required">*</span>
                          </Label>
                          <div className="radio-group d-flex align-items-center flex-wrap">
                            <FormGroup className="radioBlock">
                              <Input
                                type="radio"
                                name="marital-status"
                                className="ml-0 mt-0"
                                required
                                onChange={(e) => setCurrentValue(e.target.value)}
                                checked={currentRadioValue === 'married'}
                                value={'married'}
                              />
                              <Label className="distributor-label mb-0">Married</Label>
                            </FormGroup>
                            <FormGroup className="radioBlock">
                              <Input
                                type="radio"
                                onChange={(e) => setCurrentValue(e.target.value)}
                                name="marital-status"
                                required
                                className="ml-0 mt-0"
                                checked={currentRadioValue === 'unmarried'}
                                value={'unmarried'}
                              />
                              <Label className="dealer-label mb-0">Unmarried</Label>
                            </FormGroup>
                          </div>
                        </Col>
                        <Col md={4}>
                          <FormGroup className="birth-date-group">
                            <Label className="birth-date">
                              Birthdate <span className="required">*</span>
                            </Label>
                            <Input
                              type="date"
                              max={moment(new Date()).format('YYYY-MM-DD')}
                              onChange={handleChange}
                              value={formValues.birthDate ? formValues.birthDate : ''}
                              required={!formValues.birthDate}
                              className="birth-date-input"
                              name="birthDate"
                            />
                          </FormGroup>
                        </Col>
                        {currentRadioValue === 'married' && (
                          <Col md={4}>
                            <FormGroup className="anniversary-date-group">
                              <Label>
                                Wedding Anniversary Date
                                <span className="required">*</span>
                              </Label>
                              <Input
                                type="date"
                                className="anniversary-date-input"
                                onChange={(e) => setAnniversaryDate(e.target.value)}
                                value={anniversaryDate}
                                required={!anniversaryDate}
                                name="anniversaryDate"
                                id=""
                              />
                            </FormGroup>
                          </Col>
                        )}
                      </Row>
                      <Row>
                        <Col xs={12}>
                          <FormGroup className="setActiveOwnerBlock">
                            <Input
                              type="checkbox"
                              name="isprimary"
                              // checked={
                              //   activeOwner === 'Sole proprietorship'
                              //     ? true
                              //     : isActiveOwner
                              // }
                              checked={isActiveOwner}
                              className="active-owner ml-0"
                              onChange={(e) => {
                                // if (activeOwner === 'Sole proprietorship') {
                                //   setActiveOwner(true);
                                // } else {
                                //   setActiveOwner(e.target.checked)
                                // }
                                setActiveOwner(e.target.checked);
                              }}
                              id=""
                            />
                            <Label>Set as an Active Owner</Label>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <div className="modalBtn d-flex align-items-center justify-content-center">
                            {/* <Button className={`businessBtn noprint`}>Submit</Button> */}
                            <CommonButton
                              name={'Submit'}
                              btnClass={'btnPrimary'}
                              type="submit"
                            />
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  </Container>
                </ModalBody>
              </Modal>

              {/* Preview Doc Modal */}
              <Modal
                id="previewOwnerImgModal"
                isOpen={previewImgModal}
                toggle={togglePreviewImgModal}
                className="uploadDocModal"
                centered
              >
                <ModalBody className="pl-0 pr-0">
                  <Container>
                    <Row>
                      <Col xs={12}>
                        <div className="modalHeading">
                          <div className="title leftTitle">{title}</div>
                          <div className="closeButton">
                            <img
                              src={closeImg}
                              alt="closeImg"
                              onClick={() => setPreviewImgModal(!previewImgModal)}
                            />
                          </div>
                        </div>
                      </Col>
                      <Col xs={12} className="text-center">
                        <UploadDocPreview
                          isRemove={isPreviewRemove}
                          uploadDocpath={popupImgPreview}
                          handleRemoveClick={removeSelectedImage}
                        />
                      </Col>
                    </Row>
                  </Container>
                </ModalBody>
              </Modal>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddOwner;
